/* eslint-disable eqeqeq */
import generateVersionHash from '@utils/generateVersionHash';
import { postApi } from '@/lib/fetcher';
import { date } from '@/lib/helpers';


const mdrFileStore = {
  namespaced: true,
  state: {
    loading: false,
  },
  mutations: {
    setLoading(state, loading) {
      state.loading = loading;
    },
  },
  actions: {
    async getMdrFile(ctx, { documentId, type, filename }) {
      const URL_API = '/index.php?r=api/v1/document/document/get-custom-mdr-file';

      try {
        ctx.commit('setLoading', true);
     
        const version = generateVersionHash(String(documentId), date);

        const data = JSON.stringify({
          document_id: String(documentId),
          type,
          download: '0',
          version
        });

        const responseData = await postApi(ctx, URL_API, data);

        if (responseData?.code == 200 && responseData?.data) {
          const { base64_file: base64File, filename: responseFilename, mime } = responseData.data;
          
          const base64Data = base64File.includes(',') 
            ? base64File.split(',')[1] 
            : base64File;
          
          const byteCharacters = atob(base64Data);
          const byteNumbers = new Array(byteCharacters.length);
          
          for (let i = 0; i < byteCharacters.length; i += 1) {
            byteNumbers[i] = byteCharacters.charCodeAt(i);
          }
          
          const byteArray = new Uint8Array(byteNumbers);
          const blob = new Blob([byteArray], { type: mime || 'application/pdf' });
          const url = URL.createObjectURL(blob);

          const link = document.createElement('a');
          link.href = url;
          link.download = filename || responseFilename || 'document.pdf';
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
          
          URL.revokeObjectURL(url);
          
          return { success: true };
        }
        
        return { success: false, message: responseData?.message_id || 'Download failed' };
      } catch (error) {
        return { success: false, message: error.message };
      } finally {
        ctx.commit('setLoading', false);
      }
    },

    async getMdrFileAsFile(ctx, { documentId, type, filename }) {
      const URL_API = '/index.php?r=api/v1/document/document/get-custom-mdr-file';

      try {
        ctx.commit('setLoading', true);
     
        const version = generateVersionHash(String(documentId), date);

        const data = JSON.stringify({
          document_id: String(documentId),
          type,
          download: '0',
          version
        });

        const responseData = await postApi(ctx, URL_API, data);

        if (responseData?.code == 200 && responseData?.data) {
          const { base64_file: base64File, filename: responseFilename, mime } = responseData.data;
          
          const base64Data = base64File.includes(',') 
            ? base64File.split(',')[1] 
            : base64File;
          
          const byteCharacters = atob(base64Data);
          const byteNumbers = new Array(byteCharacters.length);
          
          for (let i = 0; i < byteCharacters.length; i += 1) {
            byteNumbers[i] = byteCharacters.charCodeAt(i);
          }
          
          const byteArray = new Uint8Array(byteNumbers);
          const blob = new Blob([byteArray], { type: mime || 'application/pdf' });
          
          const finalFilename = filename || responseFilename || 'document.pdf';
          const file = new File([blob], finalFilename, { type: mime || 'application/pdf' });
          
          return { success: true, file };
        }
        
        return { success: false, message: responseData?.message_id || 'Failed to get file' };
      } catch (error) {
        return { success: false, message: error.message };
      } finally {
        ctx.commit('setLoading', false);
      }
    },
  },
};

export default mdrFileStore;
